import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { SponsorsManager } from "@/components/admin/SponsorsManager";

export const Route = createFileRoute("/admin/sponsors")({
  component: SponsorsPage,
  head: () => ({
    meta: [
      { title: "Sponsors — Admin" },
      { name: "description", content: "Manage event sponsors" },
    ],
  }),
});

function SponsorsPage() {
  return (
    <AdminLayout>
      <SponsorsManager />
    </AdminLayout>
  );
}
